<style lang="less">
    .nullOrder{
        text-align: center;
        font-size: 14px;
        // transform: translateY(50%);
        img{
            width: 160px;
            height: 160px;
        }
        p{
            color: #BEBEBE;
        }
        >div{
            width: 100px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: linear-gradient(134deg, #FF923E 0%, #FF6F00 100%);
            opacity: 1;
            border-radius: 16px;
            margin: 30px auto;
            color: #fff;
        }
    }
</style>
<template>
    <div class="nullOrder">
        <img src="../assets/nullCar.png" alt="">
        <p>您的订单是空空如也，快去加购商品吧~</p>
        <div @click="toAIndex">去加购商品</div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        toAIndex(){
            this.$router.push({
                // path:`/`
                name:'Shop'
            })
        },
    }
}
</script>